// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={1024}
      height={357}
      viewBox="-1.983 -1.983 201.021 70.049"
      {...props}
    >
      <path
        d="M0 0h11.76l4.455 31.962h.12L20.789 0H32.55l-9.148 42.417H9.147L0 0M34.039 0h11.05v15.567h6.771V0h11.05v42.417H51.86V24.952h-6.771v17.465h-11.05V0M64.395 0h11.757l4.457 31.962h.121L85.185 0h11.759l-9.147 42.417H73.54L64.395 0"
        fill="#1e1e1e"
      />
      <path
        d="M97.576 42.414h8.907l9.222-42.41h-8.912l-9.217 42.41M111.026 42.424l8.908-.01 9.218-42.41h-8.913l-9.213 42.42M124.564 42.414h8.906l9.217-42.41h-8.906l-9.217 42.41"
        fill="#f0ab00"
      />
      <path
        d="M4.169 46.784H9.42l1.985 14.261h.05l1.99-14.261h5.247L14.61 65.712H8.247L4.165 46.784M19.356 46.784h11.216v4.031H24.29v3.234h5.882v3.87H24.29v3.763h6.517v4.03H19.356V46.784M54.93 52.247v-.45c0-1.117-.449-2.043-1.405-2.043-1.06 0-1.538.823-1.538 1.67 0 3.739 8.059 1.91 8.059 8.828 0 4.027-2.357 5.832-6.705 5.832-4.082 0-6.362-1.404-6.362-5.331v-.663h4.772v.453c0 1.615.663 2.202 1.614 2.202 1.007 0 1.594-.798 1.594-1.831 0-3.739-7.743-1.88-7.743-8.586 0-3.819 2.043-5.913 6.205-5.913 4.294 0 6.12 1.775 6.12 5.832H54.93M61.476 65.712h4.932V46.784h-4.932v18.928z"
        fill="#1e1e1e"
      />
      <path
        d="M32.477 46.784h7.714c3.766 0 5.195 2.124 5.195 5.039 0 2.516-.979 4.16-3.232 4.506 2.385.265 3.103 1.776 3.103 4.294v1.616c0 .981 0 2.251.237 2.626.132.209.237.422.558.582v.265h-5.25c-.477-1.007-.477-2.812-.477-3.603v-1.275c0-2.147-.423-2.704-1.619-2.704H37.41v7.582h-4.933V46.784zm4.933 8.008h.98c1.405 0 2.066-.9 2.066-2.252 0-1.541-.609-2.202-2.094-2.202h-.952v4.454"
        fill="#1e1e1e"
        fillRule="evenodd"
      />
      <path
        d="M75.975 52.54c0-2.147-.396-2.786-1.35-2.786-1.513 0-1.67 1.381-1.67 6.494 0 5.117.157 6.497 1.67 6.497 1.22 0 1.485-1.063 1.485-4.64h4.771v1.405c0 5.3-3.101 6.574-6.256 6.574-5.54 0-6.76-2.784-6.76-9.836 0-7.236 1.642-9.833 6.76-9.833 4.451 0 6.12 2.334 6.12 5.992v1.19h-4.77V52.54M82.524 46.784h4.928v6.948h3.02v-6.948h4.932v18.928h-4.932v-7.793h-3.02v7.793h-4.928V46.784M97.606 46.784h11.21v4.031h-6.282v3.234h5.886v3.87h-5.886v3.763h6.522v4.03h-11.45V46.784M130.526 46.784v13.655c0 1.824.559 2.306 1.485 2.306.928 0 1.485-.482 1.485-2.306V46.784h4.929v12.408c0 5.298-2.28 6.892-6.414 6.892-4.135 0-6.412-1.594-6.412-6.892V46.784h4.927M140.415 46.784h5.51l3.185 11.665h.05V46.784h4.614v18.928h-5.407l-3.288-11.689h-.05v11.689h-4.613V46.784"
        fill="#1e1e1e"
      />
      <path
        d="M110.726 46.784h7.716c3.76 0 5.192 2.124 5.192 5.039 0 2.516-.979 4.16-3.234 4.506 2.383.265 3.101 1.776 3.101 4.294v1.616c0 .981 0 2.251.238 2.626.131.209.24.422.558.582v.265h-5.251c-.477-1.007-.477-2.812-.477-3.603v-1.275c0-2.147-.422-2.704-1.612-2.704h-1.301v7.582h-4.93V46.784zm4.93 8.008h.979c1.404 0 2.07-.9 2.07-2.252 0-1.541-.61-2.202-2.095-2.202h-.954v4.454"
        fill="#1e1e1e"
        fillRule="evenodd"
      />
      <path
        d="M162.334 55.428h6.361v10.284h-3.34l-.113-1.669h-.05c-.662 1.617-2.412 2.041-4.082 2.041-5.01 0-5.459-3.58-5.459-9.836 0-6.336 1.22-9.833 7.047-9.833 3.502 0 5.993 1.775 5.993 6.36h-4.771c0-.952-.07-1.695-.266-2.198-.185-.53-.554-.823-1.139-.823-1.612 0-1.774 1.381-1.774 6.494 0 5.117.161 6.497 1.67 6.497 1.034 0 1.639-.666 1.669-3.978h-1.75v-3.339M170.577 46.784h11.213v4.031h-6.28v3.234h5.885v3.87h-5.885v3.763h6.519v4.03h-11.452V46.784M183.697 46.784h5.514l3.18 11.665h.05V46.784h4.615v18.928h-5.408l-3.284-11.689h-.05v11.689H183.7V46.784"
        fill="#1e1e1e"
      />
    </svg>
  );
};

const VhvIcon = Icon;
export default VhvIcon;
